var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-spin',{attrs:{"spinning":_vm.loading}},[_c('a-directory-tree',{attrs:{"selectedKeys":_vm.selectedKeys,"treeData":_vm.treeData},on:{"select":_vm.onSelect}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }